import {
  createContext,
  type FC,
  type ReactNode,
  useContext,
  useMemo,
} from 'react'

import { type UserOrderResponseWithFlagsSubOrdersInner } from '@redteclab/api/clients/bully'

type DirectContactFormOrderProductsSelectionContextValue = {
  isMiraklReturnAvailabilityLoading: boolean
  onClose: () => void
  onSelectProducts: (subOrder: UserOrderResponseWithFlagsSubOrdersInner) => void
}

const DirectContactFormOrderProductsSelectionContext =
  createContext<DirectContactFormOrderProductsSelectionContextValue | null>(
    null,
  )

export const useDirectContactFormOrderProductsSelectionContext =
  (): DirectContactFormOrderProductsSelectionContextValue => {
    const context = useContext(DirectContactFormOrderProductsSelectionContext)

    if (context === null) {
      throw new Error(
        'Direct contact form order product selection context is not available',
      )
    }

    return context
  }

export const DirectContactFormOrderProductsSelectionProvider: FC<{
  children: ReactNode
  isMiraklReturnAvailabilityLoading: boolean
  onClose: () => void
  onSelectProducts: (subOrder: UserOrderResponseWithFlagsSubOrdersInner) => void
}> = ({
  children,
  isMiraklReturnAvailabilityLoading,
  onClose,
  onSelectProducts,
}) => {
  const value = useMemo(
    () => ({
      isMiraklReturnAvailabilityLoading,
      onClose,
      onSelectProducts,
    }),
    [isMiraklReturnAvailabilityLoading, onClose, onSelectProducts],
  )

  return (
    <DirectContactFormOrderProductsSelectionContext.Provider value={value}>
      {children}
    </DirectContactFormOrderProductsSelectionContext.Provider>
  )
}
